<template>
    <div v-show="isActive">
        <div class="row" v-if="!questionAnswered">
            <div class="col-7 col-12-xs pb-20">
                <div class="zoom-bg">
                    <div class="d-block zoom-bg__frame">
                        <img :src="showImg(question.image)" alt="" class="zoom-bg__img"/>
                    </div>
                </div>
            </div>
            <div class="col-5 col-12-xs d-flex" style="flex-direction: column; justify-content: space-between">
                <div class="h4m mb-10">Question {{ questionNumber }} / {{ totalQuestions }}</div>

                <div v-html="question.description"></div>

                <button class="button button--ghost-inversed mb-20" @click="chooseAnswer(1)">{{ question.answerA }}</button>
                <button class="button button--ghost-inversed mb-20" @click="chooseAnswer(2)">{{ question.answerB }}</button>
                <button class="button button--ghost-inversed mb-0" @click="chooseAnswer(3)">{{ question.answerC }}</button>
            </div>
        </div>
        <div class="row" v-if="questionAnswered">
            <div class="col-7 col-12-xs pb-20">
                <div class="zoom-bg">
                    <div class="d-block zoom-bg__frame">
                        <img :src="showImg(question.image)" alt="" class="zoom-bg__img"/>
                    </div>
                    <div class="zoom-bg__overlay zoom-bg__overlay--full d-flex text-white text-center" style="justify-content: center; align-items: center">
                        <div v-if="questionAnswered && questionAnsweredCorrectly">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.2 28.2" style="max-width: 50px; margin: 0 auto">
                                <circle fill="#7ed321" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.07" cx="14.1" cy="14.1" r="13.06"/>
                                <polyline fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.07" points="20.1 10.04 12.02 18.12 8.95 15.05"/>
                            </svg>

                            <p class="mt-20">Well done!</p>
                            <p>The answer is: {{ correctAnswerText }}.</p>
                        </div>
                        <div v-if="questionAnswered && !questionAnsweredCorrectly">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.2 28.2" style="max-width: 50px; margin: 0 auto">
                                <circle stroke="currentColor" fill="#eb5346" stroke-width="2.07" stroke-miterlimit="10" cx="14.1" cy="14.1" r="13.06"/>
                                <line stroke="currentColor" fill="none" stroke-width="2.07" stroke-miterlimit="10" x1="18.56" y1="10.51" x2="10.48" y2="18.59"/>
                                <line stroke="currentColor" fill="none" stroke-width="2.07" stroke-miterlimit="10" x1="18.56" y1="18.59" x2="10.48" y2="10.51"/>
                            </svg>

                            <p class="mt-20">Wrong!</p>
                            <p>The answer actually is: {{ correctAnswerText }}.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-5 col-12-xs d-flex" style="flex-direction: column; justify-content: space-between">
                <div>
                    <div class="h4m mb-10">Question {{ questionNumber }} / {{ totalQuestions }}</div>
                    <div v-html="question.description"></div>
                </div>

                <img :src="showImg(question.answerImage)" alt="" class="zoom-bg__img"/>
                <div v-html="question.answerDescription"></div>

                <button class="button button--cta" @click="submitAnswer">Next Question</button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {showImg} from '../helpers/showImg';

export default defineComponent({
    props: {
        'isActive': {type: Boolean, required: true},
        'question': {type: Object, required: true},
        'questionNumber': {type: Number, required: true},
        'totalQuestions': {type: Number, required: true},
    },
    data() {
        return {
            chosenAnswer: null as null|number,
        };
    },
    computed: {
        questionAnswered(): boolean {
            return this.chosenAnswer !== null;
        },
        questionAnsweredCorrectly(): boolean {
            return this.chosenAnswer === this.question.correctAnswer;
        },
        correctAnswerText(): string {
            if (this.question.correctAnswer === 1) {
                return this.question.answerA;
            }

            if (this.question.correctAnswer === 2) {
                return this.question.answerB;
            }

            return this.question.answerC;
        },
    },
    watch: {
        isActive(newValue) {
            if (newValue) {
                this.triggerRetarget();
            }
        },
    },
    methods: {
        showImg(path: string): string {
            return showImg(path, 550);
        },
        chooseAnswer(chosenAnswer: number) {
            this.chosenAnswer = chosenAnswer;
            this.triggerRetarget();
        },
        submitAnswer() {
            this.$emit('answered', {
                question: this.questionNumber,
                chosenAnswer: this.chosenAnswer,
                correct: this.questionAnsweredCorrectly,
            });
        },
        triggerRetarget() {
            this.$emit('retarget', {
                [AdTargetingKey.cat]: 'single-quiz',
                [AdTargetingKey.make]: this.question.make,
                [AdTargetingKey.model]: this.question.model,
                [AdTargetingKey.vehicleType]: this.question.van ? 'van' : 'car',
            } as AdTargetingConfig);

            if (window.screen.width < 768) {
                window.scrollTo(0, 0);
            }

            window.sendAnalyticsEvent('Conversion Tracking', 'Quiz Interaction', 'Question - ' + this.questionNumber);
        },
    },
});
</script>
